import { Exclude, Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnLprObject } from './lpr-object';

export class SnLprHotListGroup extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public organization: any;

  @Expose()
  public lprHotlistObjects: SnLprObject[];

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public updatedAt: Date;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
